"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[630],{

/***/ 68219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "HU": function() { return /* binding */ FooterText; },
/* harmony export */   "O": function() { return /* binding */ CardParagraph; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* unused harmony export FooterLink */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46133);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;


var H1 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h1 */ .ZP.h1(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: 1.5rem;\n  text-align: ", ";\n  font-size: ", ";\n  @media screen and (max-width: ", ") {\n    font-size: ", ";\n  }\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.headingFontFamily;
}, function (_ref2) {
  var $textAlign = _ref2.$textAlign;
  return $textAlign ? $textAlign : 'initial';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.desktopFontSize.title;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.mobileFontSize.title;
}, function (_ref6) {
  var theme = _ref6.theme,
      $brand = _ref6.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: ", ";\n  font-size: ", ";\n  position: ", ";\n  left: ", ";\n  color: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.headingFontFamily;
}, function (_ref8) {
  var $marginBottom = _ref8.$marginBottom;
  return $marginBottom || '1.5rem';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.fontSizes[2];
}, function (_ref10) {
  var $sticky = _ref10.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref11) {
  var $sticky = _ref11.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref12) {
  var theme = _ref12.theme,
      $brand = _ref12.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.headingFontFamily;
}, function (_ref14) {
  var $color = _ref14.$color;
  return $color ? $color : 'inherit';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.fontSizes[4];
});
var H4 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h4 */ .ZP.h4(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: ", ";\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.headingFontFamily;
}, function (_ref17) {
  var $padding = _ref17.$padding;
  return $padding ? $padding : 'initial';
}, function (_ref18) {
  var theme = _ref18.theme,
      $brand = _ref18.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.typography.fontSizes[5];
}, function (_ref20) {
  var $ellipsis = _ref20.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref21) {
  var $ellipsis = _ref21.$ellipsis;
  return $ellipsis && 2;
}, function (_ref22) {
  var $ellipsis = _ref22.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref23) {
  var $ellipsis = _ref23.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref24) {
  var $ellipsis = _ref24.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref25) {
  var $ellipsis = _ref25.$ellipsis;
  return $ellipsis && '3.4rem';
});
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  text-align: ", ";\n  padding: ", ";\n  margin: initial;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: calc(\n    ", " * 2\n  );\n  color: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref27) {
  var $textAlign = _ref27.$textAlign;
  return $textAlign ? $textAlign : 'left';
}, function (_ref28) {
  var $padding = _ref28.$padding;
  return $padding ? $padding : '2rem 0';
}, function (_ref29) {
  var $fontWeight = _ref29.$fontWeight;
  return $fontWeight ? $fontWeight : 'initial';
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.typography.fontSizes[5];
}, function (_ref31) {
  var theme = _ref31.theme,
      $lineHeight = _ref31.$lineHeight;
  return $lineHeight ? $lineHeight : theme.typography.fontSizes[5];
}, function (_ref32) {
  var theme = _ref32.theme,
      $brand = _ref32.$brand,
      $color = _ref32.$color;
  return $brand ? theme.colors.primary : theme.colors[$color || 'text'];
}, function (_ref33) {
  var $ellipsis = _ref33.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref34) {
  var $ellipsis = _ref34.$ellipsis;
  return $ellipsis && 4;
}, function (_ref35) {
  var $ellipsis = _ref35.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref36) {
  var $ellipsis = _ref36.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref37) {
  var $ellipsis = _ref37.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref38) {
  var $ellipsis = _ref38.$ellipsis;
  return $ellipsis && '9.7rem';
});
var Summary = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: ", ";\n  max-width: 100vw;\n  overflow-wrap: break-word;\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n"])), function (_ref39) {
  var $textAlign = _ref39.$textAlign;
  return $textAlign ? $textAlign : 'center';
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.typography.fontSizes[3];
});
var CardParagraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  font-size: ", ";\n  line-height: calc(", " * 1.25);\n  color: ", ";\n"])), function (_ref42) {
  var theme = _ref42.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.typography.fontSizes[5];
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.typography.fontSizes[5];
}, function (_ref45) {
  var $color = _ref45.$color,
      theme = _ref45.theme;
  return $color ? $color : theme.colors.text;
});
var FooterLink = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a */ .ZP.a(_templateObject8 || (_templateObject8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref46) {
  var theme = _ref46.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref47) {
  var theme = _ref47.theme,
      $brand = _ref47.$brand;
  return $brand ? theme.colors.linkColours.alt : theme.colors.text;
}, function (_ref48) {
  var theme = _ref48.theme,
      $brand = _ref48.$brand;
  return $brand ? theme.colors.linkColours.altHover : theme.colors.text;
});
var FooterText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject9 || (_templateObject9 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: center;\n  max-width: 800px;\n  line-height: 1.2;\n  a {\n    font-family: ", ";\n    color: ", ";\n  }\n"])), function (_ref49) {
  var theme = _ref49.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref50) {
  var theme = _ref50.theme;
  return theme.colors.primary;
});

/***/ }),

/***/ 22630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getFooterProps": function() { return /* binding */ getFooterProps; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19010);
/* harmony import */ var components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68219);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46133);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33546);
/* harmony import */ var utils_strapi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61989);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);











var areas = "\nsocialMediaLogos\nfooterText\n";

var Footer = function Footer(_ref) {
  var footerText = _ref.footerText,
      links = _ref.links;
  var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .useTheme */ .Fg)();
  var isDark = theme.isDark;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(atomic_layout__WEBPACK_IMPORTED_MODULE_1__/* .Composition */ .fS, {
    areas: areas,
    justifyContent: "center",
    marginTop: "3rem",
    padding: 1,
    children: function children(Areas) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(Areas.SocialMediaLogos, {
          flex: true,
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
          paddingVertical: 2,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            href: links === null || links === void 0 ? void 0 : links.twitterLink,
            rel: "noopener noreferrer",
            target: "_blank",
            "aria-label": "Twitter",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
              src: __webpack_require__(35671),
              alt: "Twitter",
              width: 30,
              height: 30,
              style: {
                filter: !isDark && 'invert(1)',
                width: '30px',
                height: '30px'
              }
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            href: links.instagramLink,
            rel: "noopener noreferrer",
            target: "_blank",
            "aria-label": "Instagram",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
              src: __webpack_require__(46451),
              alt: "Instagram",
              width: 30,
              height: 30,
              style: {
                filter: !isDark && 'invert(1)',
                width: '30px',
                height: '30px'
              }
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            href: links.facebookLink,
            rel: "noopener noreferrer",
            target: "_blank",
            "aria-label": "Facebook",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
              src: __webpack_require__(39117),
              alt: "Facebook",
              width: 30,
              height: 30,
              style: {
                filter: !isDark && 'invert(1)',
                width: '30px',
                height: '30px'
              }
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(Areas.FooterText, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(atomic_layout__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
            maxWidthMd: 400,
            widthSmDown: '100%',
            justifyContent: "center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__/* .FooterText */ .HU, {
              $textAlign: "center",
              $padding: "initial",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_7__/* .ReactMarkdown */ .D, {
                children: footerText
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(atomic_layout__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
            maxWidthMd: 400,
            widthSmDown: '100%',
            justifyContent: "center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
              $textAlign: "center",
              $padding: "0 0 2rem 0",
              children: ["\xA9 SatsGoal ", new Date().getFullYear(), "."]
            })
          })]
        })]
      });
    }
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Footer);
function getFooterProps() {
  return _getFooterProps.apply(this, arguments);
}

function _getFooterProps() {
  _getFooterProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _yield$strapi, data, _data$attributes, twitterLink, instagramLink, facebookLink;

    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,utils_strapi__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)('/api/footer');

          case 2:
            _yield$strapi = _context.sent;
            data = _yield$strapi.data;
            _data$attributes = data.attributes, twitterLink = _data$attributes.twitterLink, instagramLink = _data$attributes.instagramLink, facebookLink = _data$attributes.facebookLink;
            return _context.abrupt("return", {
              footerText: data.attributes.footerText,
              links: {
                twitterLink: twitterLink || null,
                instagramLink: instagramLink || null,
                facebookLink: facebookLink || null
              }
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getFooterProps.apply(this, arguments);
}

/***/ }),

/***/ 39117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/facebook-f-brands.c4c8e6ea.svg","height":512,"width":320});

/***/ }),

/***/ 46451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/instagram-brands.63c8fb26.svg","height":512,"width":448});

/***/ }),

/***/ 35671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/twitter-brands.a207e8e3.svg","height":512,"width":512});

/***/ })

}]);